import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-accentcolor"]
const _hoisted_2 = {
  class: "layer",
  "data-size": "small"
}
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "add form" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = {
  class: "input",
  "data-info": ""
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "item" }
const _hoisted_14 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_15 = {
  key: 0,
  class: "list-user"
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = ["onClick", "disabled"]

import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectAssociation',
  props: {
    projectIdMaster: {},
    accentColor: {},
    headerColor: {},
    menuColor: {},
    allowedDomains: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const localizer = Localizer;
const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const projectProfiles = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

const isProjectAssociationVisible = computed(() => store.getters["projectAssociationStore/isProjectAssociationVisible"]);

onMounted(async () => {
	await getData();
});

function closeDialog() {
	let body = document.getElementsByTagName("body")[0];
	store.commit("projectAssociationStore/setIsProjectAssociationVisible", false);

	if (body.hasAttribute("data-overflow")) {
		body.removeAttribute("data-overflow");
	}
}

async function getData() {
	isLoading.value = true;

	const result = (await Axios.post(routes.PrivateArea_Project_GetProjectAssociationData, { projectIdMaster: props.projectIdMaster })).data;
	projectProfiles.value = result;

	isLoading.value = false;
}

async function submitForm() {
	isLoadingForm.value = true;
	FormHelper.removeFocus();
	validationErrors.value = [];

	try {
		await Axios.post(routes.PrivateArea_Project_SetProjectAssociation, { projectIdMaster: props.projectIdMaster, email: formData.value.email });
		formData.value.email = null;
		await getData();
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
	}

	isLoadingForm.value = false;
}

async function deleteAssociation(idMaster: string) {
	var result = confirm(localizer.get("PrivateArea.Project.DeleteAssociation_Confirm"));
	if (result) {
		isLoadingForm.value = true;
		FormHelper.removeFocus();
		validationErrors.value = [];

		try {
			await Axios.post(routes.PrivateArea_Project_DeleteProjectAssociation, { projectIdMaster: props.projectIdMaster, userIdMaster: idMaster });

			await getData();
		} catch (error) {
			if (error.response && error.response.status === 400) {
				validationErrors.value = FormHelper.getValidationErrors(error.response.data);
			}
		}

		isLoadingForm.value = false;
	}
}

function isValidationError(controlName: string): boolean {
	return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "ShareProjectBox",
    class: _normalizeClass([{'hden': !isProjectAssociationVisible.value}, 'overlay']),
    "data-accentcolor": __props.accentColor ? __props.accentColor : null
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "top",
        style: _normalizeStyle([{'background-color': __props.headerColor}])
      }, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog())),
          class: "close icon fastic-close",
          style: _normalizeStyle([{'color': __props.menuColor}])
        }, null, 4),
        _createElementVNode("div", {
          class: "title",
          style: _normalizeStyle([{'color': __props.menuColor}])
        }, _toDisplayString(_unref(localizer).get("PrivateArea.Project.ShareTitle")), 5)
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(localizer).get("PrivateArea.Project.Email")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (__props.allowedDomains)
                ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(_unref(localizer).get("PrivateArea.Project.EmailTolltip", __props.allowedDomains)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "Email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                disabled: isLoadingForm.value,
                placeholder: "email@domain.com",
                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
                class: _normalizeClass([{'input-validation-error': isValidationError('Email')}, 'textbox'])
              }, null, 42, _hoisted_12), [
                [
                  _vModelText,
                  formData.value.email,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (!isLoadingForm.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm())),
                  class: "button",
                  style: _normalizeStyle([{'background-color': __props.accentColor}])
                }, _toDisplayString(_unref(localizer).get("PrivateArea.Project.Share")), 5))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button load",
                  style: _normalizeStyle([{'background-color': __props.accentColor}])
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "loader" }, null, -1)
                ]))], 4))
          ]),
          (validationErrors.value.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(localizer).get("PrivateArea.Project.ProfileRelationList_Title")), 1),
              (projectProfiles.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(localizer).get("PrivateArea.Project.NoUser")), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectProfiles.value, (projectProfile, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "item"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(projectProfile.email), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "remove",
                    onClick: ($event: any) => (deleteAssociation(projectProfile.idMaster)),
                    disabled: isLoadingForm.value
                  }, _toDisplayString(_unref(localizer).get("PrivateArea.Project.Remove")), 9, _hoisted_20)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})